import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/service/auth/user.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styles: []
})
export class HeaderComponent implements OnInit {
    constructor(
        private userService: UserService,
        private toastr: ToastrService,
        private router: Router
    ) { }

    host: string;
    userDetails = {};

    ngOnInit() {
        this.host = this.userService.BaseHost;

        const isTechbyteAdmin = window.location.href.includes("/techbyte/admin")
        if (isTechbyteAdmin)
            this.userService.getUserProfile().subscribe(
                res => {
                    if (!res)
                        this.router.navigateByUrl('/techbyte/admin/error');

                    this.userDetails = res;
                },
                err => {
                    this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                },
            );
    }

    onLogout() {
        this.userService.logOut().subscribe(
            res => {
                localStorage.setItem("logged", "");
                window.location.href = "/techbyte/admin/login";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onHome() {
        window.location.href = "/techbyte/admin";
    }
}